export type Treatment = { name: string; price: number; type: "IM" | "IV" };

export const TREATMENTS: Treatment[] = [
  // Intramuscular
  { name: "Vitamin B12 (5mg) — Methylcobalamin", price: 50, type: "IM" },
  { name: "Vitamin B Complex (B2, B3, B5, B6)", price: 50, type: "IM" },
  { name: "Biotin (Vitamin H) B7 (5mg)", price: 50, type: "IM" },
  { name: "Glutathione (750mg)", price: 75, type: "IM" },
  { name: "Vitamin D (Colecalciferol) 7.5mg", price: 75, type: "IM" },
  // Intravenous
  { name: "ALA", price: 300, type: "IV" },
  { name: "Amino Formula ATH", price: 275, type: "IV" },
  { name: "Amino Formula FBP", price: 300, type: "IV" },
  { name: "Amino Formula FCS", price: 275, type: "IV" },
  { name: "Glutathione Push (600mg)", price: 125, type: "IV" },
  { name: "Glutathione Push (750mg)", price: 150, type: "IV" },
  { name: "NMA Formula HN", price: 325, type: "IV" },
  { name: "NMA Formula IBP", price: 300, type: "IV" },
  { name: "Mega V", price: 300, type: "IV" },
  { name: "Selenium (100mcg)", price: 250, type: "IV" },
  { name: "Ascorbic Acid (8g)", price: 250, type: "IV" },
  { name: "Ascorbic Acid (25g)", price: 275, type: "IV" },
  { name: "Myers' Cocktail", price: 250, type: "IV" },
  { name: "NAD+ (500mg)", price: 375, type: "IV" },
];

export const TREATMENT_MAP = new Map<string, Treatment>(
  TREATMENTS.map((t) => [t.name, t])
);

/** Returns 60 if any selected treatment is IV, otherwise 15 (IM only). */
export function calcClinicDuration(selectedNames: string[]): number {
  return selectedNames.some((n) => TREATMENT_MAP.get(n)?.type === "IV") ? 60 : 15;
}
